let slideIndex = 0

function showSlides() {
  const slides = document.querySelectorAll('.franchise-home-quotes__slide')
  const dots = document.querySelectorAll('.franchise-home-quotes__dot')

  if(slides.length > 0 ){
    for (const slide of slides) {
      slide.style.display = 'none'
    }
    
    slideIndex++
    
    if (slideIndex > slides.length) {
      slideIndex = 1
    }
    
    slides[slideIndex - 1].style.display = 'grid'
    setTimeout(showSlides, 5000) // Change image every 5 seconds
  }
    
  if (dots.length > 0) {
    for (const dot of dots) {
      dot.className = dot.className.replace(
        ' franchise-home-quotes__dot--active',
        ''
      )
    }

    dots[slideIndex - 1].className += ' franchise-home-quotes__dot--active'
  }
}

function init() {
  showSlides()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/quotesCarousel.js